
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class CustomerGiftCardsGrid extends Serenity.EntityGrid<CustomerGiftCardsRow, any> {
        protected getColumnsKey() { return CustomerGiftCardsColumns.columnsKey; }
        protected getDialogType() { return CustomerGiftCardsDialog; }
        protected getIdProperty() { return CustomerGiftCardsRow.idProperty; }
        protected getInsertPermission() { return CustomerGiftCardsRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerGiftCardsRow.localTextPrefix; }
        protected getService() { return CustomerGiftCardsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}